module.exports = __webpack_public_path__ + "static/media/youtube.31fefe30.svg";